
import { Options, Vue } from "vue-class-component";
import MainHeader from "./components/MainHeader.vue";
import MainHeaderSortMenu from "./components/MainHeaderSortMenu.vue";
import ScheduleDayMenuButtons from "./components/ScheduleDayMenuButtons.vue";
import SeparatorBar from "./components/SeparatorBar.vue";
import ScheduleByPlaceGrid from "./components/ScheduleByPlaceGrid.vue";
import ScheduleByHourGrid from "./components/ScheduleByHourGrid.vue";
import NoResults from "./components/NoResults.vue";
import { MutationTypes } from "./store/mutation-types";
import { useStore } from "./store";
import { sortedDays, searchFilter } from "./data/functions";
// @ts-ignore
import guest from "./data/guestData.js";
// @ts-ignore
import * as data from "./data/data.json";

@Options({
  components: {
    MainHeader,
    MainHeaderSortMenu,
    ScheduleDayMenuButtons,
    SeparatorBar,
    ScheduleByPlaceGrid,
    ScheduleByHourGrid,
    NoResults,
  },
  props: {
    eventData: Array,
  },
  mounted() {
    window.scrollTo(0, 0);
    // removes filter results on load
    this.store.commit(MutationTypes.SET_SEARCH, "");
    this.store.commit(MutationTypes.SET_SELECT_FILTERS, {
      programId: "",
      guestType: "",
      tag: [],
    }),
      this.store.commit(MutationTypes.SET_SELECT_WINDOW, {
        open: false,
        title: "",
      });
  },
  methods: {
    filteredEventsPlace(placeId: string) {
      // returns true if the events share the same place(scène) as those in the filterData array
      const filteredEvents = this.searchFilter(
        this.store.state.searchResults,
        "schedule"
      ).map((event: { sceneId: string }) => event.sceneId); // chosen by select
      return filteredEvents.includes(placeId);
    },
    filterEventsHour(hour: string) {
      // returns true if the events share the same start hour as those in the filterData array
      const filteredEvents = this.searchFilter(
        this.store.state.searchResults,
        "schedule"
      ).map((event: { showStartDate: Date }) => event.showStartDate);
      return filteredEvents.includes(hour);
    },
    filterHours() {
      // gives unique hours
      const date = this.searchFilter(
        this.store.state.searchResults,
        "schedule"
      ).map((item: any) => item.showStartDate);

      const dates = date.reduce((unique: any, item: any) => {
        const h = new Date(item).getHours();
        return unique.find((i: any) => new Date(i).getHours() === h) !==
          undefined
          ? unique
          : [...unique, item];
      }, []);

      // orders the hours
      const result = [];
      const morning = dates.filter(
        (date: any) =>
          new Date(date).getHours().toString().length === 1 &&
          "6789".includes(new Date(date).getHours().toString())
      );
      const day = dates.filter(
        (date: any) => new Date(date).getHours().toString().length === 2
      );
      const night = dates.filter(
        (date: any) =>
          new Date(date).getHours().toString().length === 1 &&
          "012345".includes(new Date(date).getHours().toString())
      );
      result.push(morning.sort(), day.sort(), night.sort());
      return result.flat();
    },
    noResults() {
      const menu = this.$store.state.activeDayMenu.menu;
      if (menu === 0) {
        const result = this.searchFilter(
          this.store.state.searchResults,
          "schedule"
        ).map((event: { sceneId: string }) => event.sceneId);
        return result.length > 0 ? false : true;
      }
      if (menu === 1) {
        const result = this.searchFilter(
          this.store.state.searchResults,
          "schedule"
        ).map((event: { showStartDate: Date }) => event.showStartDate);
        return result.length > 0 ? false : true;
      }
    },
  },
})
export default class ScheduleByPlace extends Vue {
  store = useStore();
  sortedDays = sortedDays;
  searchFilter = searchFilter;
  data: any = data;
  guestType: string[] | unknown[] = [
    ...new Set(guest.map((guest: any) => guest.type).flat()),
  ];
  tags: string[] | unknown[] = [
    ...new Set(guest.map((guest: any) => guest.tags).flat()),
  ];
  places: Object[] = data.data.scenes;
  programs: string[] = data.data.programs.map((program) => program.name).flat();
}
